// --- Tabs ---

const tabsContainer = document.getElementById('tabsContainer');
const tabsTogglers = document.querySelectorAll('#tabsContainer [data-bs-target]');

if(tabsContainer) {
    tabsContainer.addEventListener('show.bs.collapse', function (e) {
        let toggler = document.querySelector('#tabsContainer [data-bs-target="#' + e.target.id + '"]');
    
        tabsTogglers.forEach((element) => {
            element.classList.remove('active');
        });
    
        toggler.classList.add('active');
    });
}